import { blogSeoMetadata, type BlogSeoMetadata } from './blogSeoMetadata';
import { blogFaqsBySlug, type BlogFaq } from './blogFaqs';
export type { BlogFaq } from './blogFaqs';
export type BlogPost = BlogSeoMetadata & { image: string; contentHtml: string; faqs: BlogFaq[] };
const content = import.meta.glob<string>('../content/blog/*.html', { eager: true, query: '?raw', import: 'default' });
export const blogPosts: BlogPost[] = blogSeoMetadata.map(post => {
  const contentHtml = content[`../content/blog/${post.slug}.html`];
  if (!contentHtml) throw new Error(`Missing content for blog ${post.slug}`);
  return { ...post, image: post.imagePath, contentHtml, faqs: blogFaqsBySlug[post.slug] ?? [] };
});
export const blogPostsBySlug = Object.fromEntries(blogPosts.map(post => [post.slug, post]));
